import script from "./notification-rule-form.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-rule-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__